import { Route, Routes } from "react-router-dom";
import {
  Home,
  AboutPage,
  ContactPage,
  PrivacyPolicyPage,
  TermsPage,
  SearchPage,
  MembershipsPage,
  ChangelogPage,
  Login,
  Register,
  Profile,
  ConfirmEmailPage,
  Directory,
  Account,
  ResetPassword,
  ChangePassword,
  SocialLoginRedirect,
  MembershipSuccessPage,
} from "./components/views";
import NavBar from "./components/organisms/NavBars/NavBar";
import BottomNavBar from "./components/organisms/NavBars/BottomNavBar";
import { useCompanyContext, useJobPostContext } from "./providers/contexts";
import {
  ApplicationStatusModal,
  CompanyDetailsModal,
  FlagErrorModal,
  JobPostDetailsModal,
} from "./components/organisms";
import { useEffect, useRef } from "react";
import RedirectToHomeAndOpenJobModal from "./utils/validators/redirectToHomeAndOpenJobModal";

function App() {
  const hasShownAppliedModalRef = useRef(false);

  const {
    companyModalOpen,
    company,
    closeCompanyDetailsModal,
    loading: companyContextLoading,
    error: companyContextError,
    flagCompanyModalOpen,
    closeFlagCompanyModal,
  } = useCompanyContext();

  const {
    flagJobPostModalOpen,
    loading: jobPostDetailsLoading,
    error: jobPostDetailsError,
    jobPost,
    closeJobPostDetailsModal,
    closeFlagJobPostModal,
    jobPostDetailsModalOpen,
    recentlyAppliedJobId,
    showAppliedModal,
    setShowAppliedModal,
    closeAppliedModal,
  } = useJobPostContext();

  useEffect(() => {
    const handleWindowFocus = () => {
      if (recentlyAppliedJobId && !hasShownAppliedModalRef.current) {
        setShowAppliedModal(true);
        hasShownAppliedModalRef.current = true;
      }
    };

    window.addEventListener("focus", handleWindowFocus);
    return () => window.removeEventListener("focus", handleWindowFocus);
  }, [recentlyAppliedJobId]);

  useEffect(() => {
    hasShownAppliedModalRef.current = false;
  }, [recentlyAppliedJobId]);

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />
        <Route path="/memberships" element={<MembershipsPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/directory" element={<Directory />} />
        <Route path="/confirm-email" element={<ConfirmEmailPage />} />
        <Route path="/membership-success" element={<MembershipSuccessPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/account" element={<Account />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/social-login" element={<SocialLoginRedirect />} />

        <Route path="/job" element={<RedirectToHomeAndOpenJobModal />} />
      </Routes>

      {companyModalOpen && (
        <CompanyDetailsModal
          companyModalOpen={companyModalOpen}
          onCloseButtonClick={closeCompanyDetailsModal}
          company={company}
          loading={companyContextLoading}
          error={companyContextError}
        />
      )}

      {flagCompanyModalOpen && company && (
        <FlagErrorModal
          componentName="flag-company"
          type="company"
          company={company}
          open={flagCompanyModalOpen && company?.id !== undefined}
          onCloseButtonClick={() => closeFlagCompanyModal()}
          header="Flag Company For An Error"
          subheader={`Company: ${company.company_name}`}
        />
      )}

      {jobPostDetailsModalOpen && jobPost && (
        <JobPostDetailsModal
          loading={jobPostDetailsLoading}
          error={jobPostDetailsError ?? undefined}
          onCloseButtonClick={() => closeJobPostDetailsModal()}
          jobPost={jobPost}
          jobPostDetailsModalOpen={jobPostDetailsModalOpen}
        />
      )}

      {flagJobPostModalOpen && jobPost && (
        <FlagErrorModal
          componentName="flag-job-post"
          type="jobPost"
          jobPost={jobPost}
          open={flagJobPostModalOpen && jobPost?.id !== undefined}
          onCloseButtonClick={() => closeFlagJobPostModal()}
          header="Flag Job Post For An Error"
          subheader={`Job Post ${jobPost.job_title} at ${jobPost.company.company_name}`}
        />
      )}

      {showAppliedModal && recentlyAppliedJobId && jobPost && (
        <ApplicationStatusModal
          jobPostId={jobPost.id}
          jobPostTitle={jobPost?.job_title ?? ""}
          companyName={jobPost?.company.company_name ?? ""}
          showAppliedModal={showAppliedModal}
          handleLeftButtonClick={closeAppliedModal}
        />
      )}
      <BottomNavBar />
    </>
  );
}

export default App;
